import Subdiagram from '../models/Subdiagram'

const subdiagramFactory = {
  create: (id: number, description: string) => new Subdiagram(id, description)
}

export default subdiagramFactory
